import _ from 'lodash';
import template from './planRada.html';

class PlanRadaController {
    constructor(DS, AppConfiguration, $q, $uibModal, $state, logger) {
        this.datastore = () => DS;
        this.$q = () => $q;
        this.$uibModal = () => $uibModal;
        this.$state = () => $state;
        this.logger = () => logger;
        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
        this.pageTitle = 'Plan rada';
    }

    $onInit() {
        const DS = this.datastore();
        DS.find('RadniNalog', this.id, { bypassCache: true }).then(radniNalog => {
            this.item = radniNalog;
            this.pageTitle = `Plan rada: ${radniNalog.pacijent}`;
            this.refreshState();
        });
    }

    refreshState() {
        const DS = this.datastore();
        const $q = this.$q();
        this.nalog = this.item;
        this.stavke = _.cloneDeep(this.nalog.stavke);
        this.veze = _.cloneDeep(this.nalog.veze);

        this.pozicije = [];
        this.stavke.forEach(stavka => {
            this.pozicije.push({ broj: stavka.pozicija, selected: true, veza: false });
        });
        this.veze.forEach(veza => {
            this.pozicije.push({ broj: veza.pozicija, selected: true, veza: true });
        });

        $q.all([DS.findAll('ProtetskiRad'), DS.findAll('Cjenik')]).then(response => {
            this.groupStavke(this.stavke);
        });
    }

    copyStavke(from, to) {
        if (from && from.selected && from.broj !== to.broj && !to.veza && !from.veza) {
            let stavke = _.filter(this.stavke, { pozicija: from.broj });
            let clones = _.cloneDeep(stavke);
            _.forEach(clones, clone => {
                // debugger;
                clone.pozicija = to.broj;
                this.stavke.push(clone);
                this.pozicije.push(Object.assign({}, to, { selected: true }));
            });

            this.groupStavke(this.stavke);
        }
    }

    groupStavke(stavke) {
        // grupiraj stavke naloga po protetskom radu
        // {
        //     "protetski_rad": 21,
        //     "pozicije": [
        //            12,
        //            22,
        //            18
        //     ],
        //     cjenik: 1
        // },
        const DS = this.datastore();
        const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
        this.groupedStavke = StavkaNaloga.group(stavke);
    }

    pozicijaClicked(pozicija) {
        if (_.isObject(pozicija) && !pozicija.veza) {
            this.insertStavkuNaloga(pozicija).then(() => {
                this.pozicije.push(Object.assign({}, pozicija, { selected: true }));
            });
        } else {
            // ako je veza već odbrana makni je iz liste,
            // ako nije stavie je u listu odabranih veza
            const veza = _.find(this.veze, item => {
                return item.pozicija === pozicija.broj;
            });

            if (veza) {
                this.pozicije = _.filter(this.pozicije, item => {
                    return item.broj !== veza.pozicija;
                });
                this.removeVezuNaloga(veza);
            } else {
                this.pozicije.push(Object.assign({}, pozicija, { selected: !pozicija.selected }));
                this.insertVezuNaloga(pozicija);
            }
        }
    }

    insertVezuNaloga(pozicija) {
        this.veze.push({ pozicija: pozicija.broj });
    }

    insertStavkuNaloga(pozicija) {
        const $uibModal = this.$uibModal();
        const model = {};

        if (_.isObject(pozicija)) {
            model.pozicija = pozicija.broj;
        }

        const modal = $uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg-extra',
            // windowClass: 'modal-lg-extra',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        return modal.result.then(model => {
            this.stavke.push(model);
            this.groupStavke(this.stavke);
        });
    }

    removeStavkuNaloga(item) {
        _.remove(this.stavke, stavka => {
            return stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik;
        });

        item.pozicije.forEach(pozicija => {
            const poz = _.findIndex(this.pozicije, i => {
                return i.broj === pozicija;
            });

            if (poz !== -1) {
                this.pozicije.splice(poz, 1);
            }
        });
        this.groupStavke(this.stavke);
    }

    removeVezuNaloga(item) {
        _.remove(this.veze, veza => {
            return veza.pozicija === item.pozicija;
        });
    }

    submit() {
        // this.onSubmit({stavke: this.stavke, veze: this.veze});
        const DS = this.datastore();
        const $state = this.$state();
        const logger = this.logger();
        DS.update('PlanRada', this.item.id, { stavke: this.stavke, veze: this.veze })
            .then(response => {
                this.item.stavke = response.stavke;
                this.item.veze = response.veze;
                $state.go('radniNalog.details', { id: this.item.id });
            })
            .catch(error => {
                logger.error('Oupss....', error.data);
            });
    }
}

PlanRadaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', '$state', 'logger'];

const PlanRadaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PlanRadaController,
    controllerAs: 'vm',
    bindings: {
        id: '<'
    }
};

export { PlanRadaComponent };
export { PlanRadaController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/planRada.component.js